import { useQuery } from "@apollo/client";
import { GetPayPeriodEndDatesQuery, GetPayPeriodEndDatesQueryVariables } from "generated/graphql";
import queries from "Shared/queries";

export const usePayPeriodEndDates = () => {
  const { data } = useQuery<
    GetPayPeriodEndDatesQuery,
    GetPayPeriodEndDatesQueryVariables
  >(queries.GET_PAY_PERIOD_END_DATES);

  return {
    endDates: data?.employer.currentProvider.payPeriodEndDates,
  };
};
